<ng-template #modalPixKey let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      <i class="fa fa-pix"></i> {{ changing ? "Alterar" : "Cadastrar" }} chave pix
    </h4>
    <button
      type="button"
      class="sf-btn sf-btn--ghost sf-btn--icon sf-btn--sm"
      aria-label="Fechar"
      (click)="modal.dismiss()"
    >
      <i class="fa fa-times"></i>
    </button>
  </div>

  <div class="modal-body">
    <div class="field">
      <label for="pix_key">Chave pix</label>
      <input
        class="form-control"
        type="text"
        name="pix_key"
        id="pix_key"
        [(ngModel)]="pixKey"
        (keypress)="checkKey($event)"
      />
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="sf-btn sf-btn--ghost push" (click)="modal.close('NO')">
      Cancelar
    </button>
    <button type="button" class="sf-btn sf-btn--primary" (click)="save()">
      {{ changing ? "Alterar" : "Cadastrar" }}
    </button>
  </div>
</ng-template>
